export default "__VITE_ASSET__7f6e5f5c__"